module.exports = __webpack_public_path__ + "static/media/01-Startpage-Vehicle-01-PKW.d0eca108.png";